import React from 'react'
import { styled } from '@mui/material/styles'
import { TextFieldProps, Toolbar, OutlinedInput, InputAdornment } from '@mui/material'
import Iconify from './Iconify'
import { useTranslation } from 'react-i18next'

type Props = TextFieldProps & {
  title?: string
  data: any[]
  params?: any[]
  action?: any
}

const StyledRoot = styled(Toolbar)(() => ({
  width: '99%',
  display: 'flex',
  justifyContent: 'space-between',
  padding: '0 !important'
}))

const StyledSearch = styled(OutlinedInput)(({ theme }: any) => ({
  width: '100%',
  height: 36,
  backgroundColor: theme.palette.grey[800]
}))

export function InputSearch ({ title, data, params, action }: Props) {
  const dataFound: string[] = []
  const { t } = useTranslation()
  const handleSearch = (searchText: any) => {
    const regex = new RegExp(searchText.normalize('NFD').replace(/[\u0300-\u036f\W_]/g, ''), 'i')

    data.forEach((obj) => {
      Object.entries(obj).forEach(([key, value]) => {
        if (Array.isArray(value) && key === 'labels') {
          Object.entries(value).forEach(([keyLabel, label]) => {
            if (!dataFound.includes(obj) && (params?.includes?.(key) ?? !params) &&
              regex.exec(label.name.normalize('NFD').replace(/[\u0300-\u036f\W_]/g, '') as string)) {
              dataFound.push(obj)
            }
          })
          return
        }
        if (!Array.isArray(value) && !dataFound.includes(obj) &&
          (params?.includes?.(key) ?? !params) &&
          regex.exec(obj[key].normalize('NFD').replace(/[\u0300-\u036f\W_]/g, '') as string)) {
          dataFound.push(obj)
        }
      })
    })
  }

  return (
    <StyledRoot>
      <StyledSearch
        onChange={(event: any) => {
          handleSearch(event.target.value)
          action(dataFound)
        }}
        placeholder={title}
        startAdornment={
          <InputAdornment position="start">
            <Iconify icon="eva:search-fill" sx={{ color: 'text.disabled', width: 20, height: 20 }} />
          </InputAdornment>
        }
      />
    </StyledRoot>
  )
}
